import React from "react";
import moment from "moment";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import axios from "../../api/axios";
import { format } from "date-fns";
import {
  TailwindToaster,
  ConfirmationModal,
  numberToINR,
  PropertyThumbnail,
  Assignee,
  ChangeAssigneeOverlay,
} from "../../components";
import { FileUploader } from "react-drag-drop-files";
import CryptoJS from "crypto-js";
import { downloadBlobFile, uploadBlobToContainer } from "../../api/azure";

const ServicesViewSpecific = () => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.UserReducer);
  const { serviceTicketId } = useParams();
  const serviceticketUrl = "/serviceticket";
  const serviceCommentsUrl = "/servicecomment";
  const serviceSubStatusUrl = "/servicesubstatus";
  const addressBookUrl = "/addressbook";
  const blobContainerName = "serviceticketattachments";
  const enquiryCommentsUrl = "/enquirycomment";

  const [validCommentDescription, setCommentDescriptionValidity] =
    React.useState(true);
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [isFileUploading, setIsFileUploading] = React.useState(false);

  const [serviceTicketDataFromServer, setServiceTicketDataFromServer] =
    React.useState({});
  const [serviceAddressBook, setServiceAddressBook] = React.useState({});
  const [serviceCommentsData, setServiceCommentsData] = React.useState([]);
  const [enquiryCommentsData, setEnquiryCommentsData] = React.useState([]);
  const [serviceTasksData, setServiceTasksData] = React.useState([]);
  const [serviceSubStatusData, setServiceSubStatusData] = React.useState([]);
  const [editStatus, setEditStatus] = React.useState(false);
  const [editSubStatus, setEditSubStatus] = React.useState(false);

  const [editAssigneeId, setEditAssigneeId] = React.useState(null);

  const transformAddress = (item) => {
    const addressString = [
      item.addressline1?.replace(",", " ").trim(),
      item.addressline2?.replace(",", " ").trim(),
      item.city?.replace(",", " ").trim(),
      item.state?.replace(",", " ").trim(),
    ];
    const filtered = addressString.filter((item) => {
      return (
        item &&
        item !== null &&
        item !== undefined &&
        item.toString().trim() !== ""
      );
    });
    if (filtered.join("").trim() !== "") {
      return filtered.join(", ").trim();
    }
    return "";
  };

  const renderServiceTaskStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-xs font-semibold px-1.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN-PROCESS
          </span>
        );
      default:
        return (
          <span className='bg-red-100 text-red-600 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            {status}
          </span>
        );
    }
  };
  const renderStatus = (status) => {
    if (status === undefined)
      return (
        <span className='bg-orange-100 text-orange-800 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
          #BLANK
        </span>
      );
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ON-HOLD":
        return (
          <span className='bg-orange-100 text-orange-800 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ON-HOLD
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN&nbsp;PROCESS
          </span>
        );
      case "DROPPED":
        return (
          <span className='bg-red-100 text-red-600 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            DROPPED
          </span>
        );
      default:
        return (
          <span className='bg-orange-100 text-orange-800 text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            {status}
          </span>
        );
    }
  };

  const renderTags = (tags) => {
    const tagsArray = tags.split(" ");
    var returnText = "";
    tagsArray.forEach((element) => {
      returnText += "#" + element + " ";
    });
    return returnText.trim();
  };

  const postComment = (event) => {
    var canSubmit = true;
    const serviceCommentData = new FormData(event.target);

    setCommentDescriptionValidity(true);

    if (serviceCommentData.get("commentDescription") === "") {
      setCommentDescriptionValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);

    const dataToSubmit = {
      serviceTicketId,
      description: serviceCommentData.get("commentDescription"),
      tags: serviceCommentData.get("commentTags"),
      commentAttachments,
    };
    try {
      axios
        .post(serviceCommentsUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            document.getElementById("serviceCommentForm").reset();
            document.getElementById("serviceCommentForm1").reset();
            setCommentAttachments([]);
            // getServiceTicket();
            setServiceCommentsData(response.data.serviceComments);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [commentAttachments, setCommentAttachments] = React.useState([]);

  React.useEffect(() => {
    console.log(commentAttachments);
  }, [commentAttachments]);

  const uploadCommentAttachments = async (files) => {
    setIsFileUploading(true);
    let latestAttachments = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") +
        "." + // + ".crypt";
        fileExtension;

      const uploadedItem = {
        blobName,
        originalname: files[i].name,
        contentType: files[i].type,
        blobContainerName: "erpmvpblobstorage",
      };
      try {
        // const uploadBlobResult = await uploadBlobToContainer(
        //   blobContainerName,
        //   blobName,
        //   files[i],
        // );
        // if (uploadBlobResult.status === "success") {
        //   const blobItem = {
        //     originalname: files[i].name,
        //     size: files[i].size,
        //     blobContainer: blobContainerName,
        //     blobName,
        //     mimetype: files[i].type,
        //   };
        //   latestAttachments.push(blobItem);
        // }

        const renamedFile = new File([files[i]], blobName, {
          type: files[i].type,
        });
        const formData = new FormData();
        formData.append("file", renamedFile);
        formData.append("blobName", blobName);

        const resp = await axios.post(serviceCommentsUrl + "/upload", formData);
        if (resp.status === 200) {
          // const uploadedItem = {};
          console.log(uploadedItem);
          latestAttachments.push(uploadedItem);
        } else {
          toast.error("Error uploading file");
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
    }
    if (commentAttachments.length > 0)
      setCommentAttachments(commentAttachments.concat(latestAttachments));
    else setCommentAttachments(latestAttachments);
    setIsFileUploading(false);
  };

  const removeCommentAttachment = (serverblobName) => {
    const filteredAttachments = commentAttachments.filter((item) => {
      return item.blobName !== serverblobName;
    });
    setCommentAttachments(filteredAttachments);
  };

  const [popupId, setPopupId] = React.useState(null);
  const removeActivity = (serviceCommentId) => {
    setPopupId(serviceCommentId);
  };

  const closeConfirmation = () => {
    setPopupId(null);
  };
  const popupCallback = (canProceed) => {
    if (canProceed) removeActivityServer(popupId);
    setPopupId(null);
  };

  const removeActivityServer = (serviceCommentId) => {
    try {
      axios
        .delete(serviceCommentsUrl + "/" + serviceCommentId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            getServiceTicket();
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [downloadBlobFileName, setDownloadBlobFile] = React.useState(null);
  const downloadAttachment = async (
    blobContainer,
    blobName,
    originalname,
    mimetype,
  ) => {
    try {
      setDownloadBlobFile(blobName);
      // Azure Stuff
      // const azureDownloadresult = await downloadBlobFile(
      //   blobContainer,
      //   blobName,
      //   originalname,
      // );
      // if (azureDownloadresult.status === "success") {
      //   const azureData = azureDownloadresult.data;
      //   const downloadFileUrl = window.URL.createObjectURL(azureData);
      //   const temporaryDownloadLink = document.createElement("a");
      //   temporaryDownloadLink.href = downloadFileUrl;
      //   temporaryDownloadLink.setAttribute("download", originalname);
      //   temporaryDownloadLink.click();
      // } else {
      //   toast.error("Something went wrong with file download");
      // }

      // GCS Stuff
      const response = await axios.get(
        serviceCommentsUrl + "/download/" + blobName,
        {
          responseType: "blob",
        },
      );
      const blob = new Blob([response.data], {
        type: "application/octet-stream",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = originalname;
      link.click();
      setDownloadBlobFile(null);
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getServiceTicket = () => {
    try {
      axios
        .get(serviceticketUrl + "/" + serviceTicketId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTicket) {
            setServiceTicketDataFromServer(response.data.serviceTicket);
            setServiceCommentsData(response.data.serviceComments);
            setServiceTasksData(response.data.serviceTasks);
            setServiceAddressBook(response.data.crm);
            getServiceSubStatus(
              response.data.serviceTicket.serviceTypeId._id,
              response.data.serviceTicket.subServiceTypeId._id,
            );
            setPageTitle(
              "Service #" +
                response.data.serviceTicket.serviceTicketID +
                " - L&L ERP",
            );
            setEnquiryCommentsData(response.data.enquiryComments);
          } else {
            toast.error("Service Ticket Details not found");
            navigate(-1);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getServiceSubStatus = (serviceId, subServiceId) => {
    try {
      axios
        .get(serviceSubStatusUrl + "/" + serviceId + "/" + subServiceId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceSubStatuss) {
            setServiceSubStatusData(response.data.serviceSubStatuss);
          } else {
            toast.error("Service SubStatus Details not found");
            navigate(-1);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const changeStatus = (status, statusText) => {
    try {
      axios
        .put(
          serviceticketUrl + "/status/" + serviceTicketId,
          JSON.stringify({
            status,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          setEditStatus(false);
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setServiceTicketDataFromServer({});
            getServiceTicket();
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => {
          setEditStatus(false);
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      setEditStatus(false);
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const changeSubStatus = (subStatusId, subStatusText) => {
    if (
      subStatusText.trim().replace(" ", "").toLowerCase() === "crm-completed" &&
      state.user?.department?.name?.toLowerCase() !== "crm"
    ) {
      toast.error("Only CRM Team can Close Ticket");
    } else {
      try {
        axios
          .put(
            serviceticketUrl + "/substatus/" + serviceTicketId,
            JSON.stringify({
              subStatusId,
            }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: state.user.token,
              },
            },
          )
          .then((response) => {
            setEditSubStatus(false);
            if (response?.data?.status === "success") {
              toast.success(response?.data?.message);
              setServiceTicketDataFromServer({});
              getServiceTicket();
            } else {
              toast.error(response?.data?.message);
            }
          })
          .catch((err) => {
            setEditSubStatus(false);
            toast.error("Something went wrong");
            console.log(err);
          });
      } catch (err) {
        setEditSubStatus(false);
        toast.error("Something went wrong");
        console.log(err);
      }
    }
  };

  const [pageTitle, setPageTitle] = React.useState("Service - L&L ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const [updatedAssignee, setUpdatedAssignee] = React.useState(0);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getServiceTicket();
    setEditAssigneeId(null);
  }, [updatedAssignee]);

  return (
    <>
      {editAssigneeId && (
        <ChangeAssigneeOverlay
          updatedAssignee={updatedAssignee}
          setUpdatedAssignee={setUpdatedAssignee}
          item={serviceTicketDataFromServer}
          closeConfirmation={closeConfirmation}
        />
      )}
      {popupId && (
        <ConfirmationModal
          actionName={<strong>Delete Activity</strong>}
          deleteConfirmation={popupCallback}
          moduleName={"Delete Activity (irreversible)"}
          itemName={"of Service"}
          closeConfirmation={closeConfirmation}
        />
      )}
      <div className='min-h-full'>
        <TailwindToaster />
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8 '>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <div className='shadow overflow-hidden sm:rounded-md'>
                  <div className='px-4 py-5 bg-white sm:p-6'>
                    <div className='flex lg:items-center justify-between'>
                      <div className='flex flex-col min-w-0 px-0 justify-between'>
                        <div className='flex-col'>
                          <h2 className='text-base font-semibold leading-3 text-gray-dark '>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <p>Service Ticket</p>
                            ) : (
                              <span className='mt-1 block w-full py-0  sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                  <div className='w-56 bg-yellow-2 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </h2>
                          <h2 className='text-sm font-medium sm:mt-5 mt-2 sm:leading-3 leading-4 text-gray-700 '>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <p>
                                #{serviceTicketDataFromServer?.serviceTicketID}
                                {" / "}
                                {serviceTicketDataFromServer?.leadEnteredDate
                                  ?.toString()
                                  .slice(0, 10)}
                                {serviceTicketDataFromServer?.addressBookId && (
                                  <Link
                                    to={
                                      "/addressbook/" +
                                      serviceTicketDataFromServer?.addressBookId
                                        ?._id
                                    }>
                                    {" / "}
                                    {serviceTicketDataFromServer?.addressBookId
                                      ?.prefix +
                                      ". " +
                                      serviceTicketDataFromServer?.addressBookId
                                        ?.firstName +
                                      " " +
                                      (serviceTicketDataFromServer
                                        ?.addressBookId?.lastName
                                        ? serviceTicketDataFromServer
                                            ?.addressBookId?.lastName
                                        : "")}
                                    {" / "}
                                    {serviceTicketDataFromServer?.addressBookId
                                      ? serviceTicketDataFromServer
                                          ?.addressBookId?.crm?._id ===
                                        "636751da314cd73283ec3671"
                                        ? "+" +
                                          serviceTicketDataFromServer
                                            ?.addressBookId?.countryCode +
                                          " " +
                                          serviceTicketDataFromServer?.addressBookId?.phoneNumber.slice(
                                            0,
                                            2,
                                          ) +
                                          "xxx xxx" +
                                          serviceTicketDataFromServer?.addressBookId?.phoneNumber.slice(
                                            7,
                                            10,
                                          )
                                        : ["super-admin", "admin"].includes(
                                            state.user.aclGroup?.toLowerCase(),
                                          ) ||
                                          serviceTicketDataFromServer.assignee
                                            ?.teamId ===
                                            state.user?.team?._id ||
                                          state?.user?.department?._id ===
                                            "62f282e173c00d96df72aa30"
                                        ? "+" +
                                          serviceTicketDataFromServer
                                            ?.addressBookId?.countryCode +
                                          " " +
                                          serviceTicketDataFromServer
                                            ?.addressBookId?.phoneNumber
                                        : "+" +
                                          serviceTicketDataFromServer
                                            ?.addressBookId?.countryCode +
                                          " " +
                                          serviceTicketDataFromServer?.addressBookId?.phoneNumber.slice(
                                            0,
                                            2,
                                          ) +
                                          "xxx xxx" +
                                          serviceTicketDataFromServer?.addressBookId?.phoneNumber.slice(
                                            8,
                                            10,
                                          )
                                      : "--"}
                                  </Link>
                                )}
                              </p>
                            ) : (
                              <span className='mt-1 block w-full py-0 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                  <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </h2>
                        </div>
                        <div className=''>
                          {((serviceTicketDataFromServer?.serviceTypeId?.name
                            ?.toLowerCase()
                            .includes("brokerage") &&
                            serviceTicketDataFromServer?.subServiceTypeId?.name
                              ?.toLowerCase()
                              .includes("sell")) ||
                            (serviceTicketDataFromServer?.serviceTypeId?.name
                              ?.toLowerCase()
                              .includes("rental") &&
                              serviceTicketDataFromServer?.subServiceTypeId?.name
                                ?.toLowerCase()
                                .includes("landlord"))) &&
                            (serviceTicketDataFromServer?.propertyInformationId ? (
                              <div className='ml-0 mt-2 flex flex-row'>
                                <Link
                                  to={
                                    "/serviceticket/pif/" +
                                    serviceTicketDataFromServer
                                      ?.propertyInformationId?._id
                                  }
                                  className='peer justify-center py-1.5 px-3 border-yellow-2 border shadow-sm text-sm font-semibold rounded text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                                  View PIF
                                </Link>
                                <Link
                                  to={
                                    "/serviceticket/pif/edit/" + serviceTicketId
                                  }
                                  className='ml-2 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'>
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    className='h-6 w-6'
                                    viewBox='0 0 20 20'
                                    fill='currentColor'>
                                    <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                  </svg>
                                </Link>
                              </div>
                            ) : (
                              <button
                                id='createPIFBtn'
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(
                                    "/serviceticket/pif/create/" +
                                      serviceTicketId,
                                  );
                                }}
                                className='ml-0 mt-2 justify-center py-1.5 px-3 border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none '>
                                Create PIF
                              </button>
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className='mt-5 grid-cols-12 gap-3 sm:grid hidden'>
                      <div className='col-span-8'>
                        <div className='pr-10'>
                          <label
                            htmlFor='prefix'
                            className='block text-base font-semibold text-gray-dark'>
                            Service Information
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-5 text-sm text-justify leading-5 '>
                              {serviceTicketDataFromServer?.enquiryId
                                ? serviceTicketDataFromServer.enquiryId
                                    .serviceInformation
                                : serviceTicketDataFromServer?.serviceInformation}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        {serviceTicketDataFromServer?.taggedPif?.length > 0 && (
                          <div className='mt-4'>
                            <label
                              htmlFor='backgroundInformation'
                              className='block text-base font-semibold text-gray-dark'>
                              Tagged Properties
                            </label>
                            <div className='pt-4 grid grid-cols-12 gap-5'>
                              {serviceTicketDataFromServer?.taggedPif.map(
                                (item, index) => (
                                  <div
                                    key={item._id}
                                    onClick={(e) => {
                                      window.open(
                                        "/property/" + item._id,
                                        "_blank",
                                      );
                                    }}
                                    className='relative flex-col col-span-5 sm:col-span-2 pt-0 bg-yellow-50 hover:border-yellow-dark duration-300 cursor-default border-gray-50 shadow-sm hover:shadow-xl hover:shadow-yellow-3 opacity-90 hover:opacity-100 '>
                                    <div className='justify-center max-h-56 bg-yellow-dark overflow-hidden '>
                                      <PropertyThumbnail
                                        key={item.blobName}
                                        thumbnail={item.thumbnail}
                                        isthumbnail={true}
                                      />
                                    </div>
                                    <div className='absolute bottom-0 left-0 bg-yellow-light bg-opacity-100 w-full duration-300'>
                                      <div className='flex flex-col'>
                                        <div className=' px-4 py-2'>
                                          <div className='flex justify-between'>
                                            <span className='text-sm font-semibold text-gray-dark'>
                                              Service #
                                              {
                                                item.serviceTicketId
                                                  .serviceTicketID
                                              }
                                            </span>
                                          </div>
                                          <div className='flex-col'>
                                            <div className='-mt-1'>
                                              <span className='pt-0 text-xs font-semibold text-gray-dark w-full leading-3'>
                                                {numberToINR(item.price)}
                                              </span>
                                            </div>
                                            <div className='mt-1'>
                                              <p className='pt-0 text-xs font-normal  text-gray-dark w-full leading-normal'>
                                                {transformAddress(item)}
                                                {item.pincode
                                                  ? "- " + item.pincode
                                                  : ""}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <div
                                          className='flex justify-center w-full bg-yellow-2 duration-300 hover:bg-yellow-dark cursor-pointer py-2.5'
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            untagProperty(index);
                                          }}>
                                          <span className='text-sm font-medium'>
                                            Untag
                                          </span>
                                        </div> */}
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        )}
                        <h2 className='text-base font-semibold leading-3 text-gray-dark mt-8'>
                          Activity
                        </h2>
                        <div className='my-2 p-2 pt-1 pb-0 flex'>
                          <div className='p-1'>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <img
                                src={
                                  state?.user?.avatar
                                    ? state?.user?.avatar
                                    : "/assets/images/user.png"
                                }
                                alt='User'
                                referrerPolicy='no-referrer'
                                className='h-8 w-8 rounded-full '
                              />
                            ) : (
                              <div className='animate-pulse w-8 bg-gray-300 h-8 rounded-full'></div>
                            )}
                          </div>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <div className='flex-row overflow-x-auto px-3 rounded-lg py-3 bg-gray-100 w-full'>
                              <form
                                action='#'
                                method='POST'
                                id='serviceCommentForm'
                                noValidate
                                onSubmit={(event) => {
                                  event.preventDefault();
                                  postComment(event);
                                }}>
                                <div className='text-xs font-semibold py-0.25 text-blue-800 '>
                                  <input
                                    type='text'
                                    name='commentTags'
                                    id='commentTags'
                                    maxLength='50'
                                    placeholder='Tags can be split using spacebar'
                                    className={`mt-0 focus:ring-yellow-2 focus:border-yellow-2 block w-6/12 shadow-sm text-xs border-0 bg-yellow-50 py-1 px-2 rounded-sm`}
                                  />
                                </div>
                                <textarea
                                  name='commentDescription'
                                  id='commentDescription'
                                  rows={4}
                                  placeholder='Write Comments here..'
                                  className={`mt-1 w-full border-0 bg-gray-50 ${
                                    !validCommentDescription
                                      ? "border ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                      : "focus:ring-yellow-2 focus:border-yellow-2"
                                  }  block shadow-sm text-xs  rounded-md`}
                                />
                                {!validCommentDescription && (
                                  <p className='text-red-600 text-xs font-semibold'>
                                    Comment invalid
                                  </p>
                                )}
                                <div className='flex'>
                                  {commentAttachments.length > 0 ? (
                                    commentAttachments.map((item) => (
                                      <div
                                        key={item.blobName}
                                        className='my-2 mr-1 px-1.5 py-1 bg-white rounded z-0'>
                                        <div className='flex'>
                                          <div className='font-semibold text-yellow-dark mt-0.25 text-xs'>
                                            {item.originalname?.length > 30
                                              ? item.originalname?.slice(
                                                  0,
                                                  30,
                                                ) + "..."
                                              : item.originalname}
                                          </div>
                                          <div
                                            className='ml-2 cursor-pointer'
                                            onClick={(e) => {
                                              e.preventDefault();
                                              removeCommentAttachment(
                                                item.blobName,
                                              );
                                            }}>
                                            <img
                                              className={`h-4 w-4`}
                                              src='/assets/icons/trash-filled.png'
                                              alt='X'
                                              title='Remove attachment'
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                                <div className=''>
                                  {isFileUploading ? (
                                    <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer animate-bounce opacity-60'>
                                      <p className='p-3'>
                                        File Uploading to Server...
                                      </p>
                                    </div>
                                  ) : (
                                    <FileUploader
                                      handleChange={uploadCommentAttachments}
                                      name='attachments'
                                      multiple={true}
                                      label='Upload or Drop files to move enquiry to Service ticket'
                                      children={
                                        <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer'>
                                          <p className='p-3'>
                                            Drag &amp; Drop files here
                                          </p>
                                        </div>
                                      }
                                      types={["JPG", "PNG", "PDF"]}
                                    />
                                  )}
                                </div>
                                <div className='ml-0 pb-1'>
                                  {!requestLoading ? (
                                    <button
                                      id='submitBtn'
                                      className='mt-2 inline-flex justify-center py-1 px-3 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none '>
                                      Add Activity
                                    </button>
                                  ) : (
                                    <button
                                      className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                                      disabled={true}>
                                      Processing...
                                    </button>
                                  )}
                                </div>
                              </form>
                            </div>
                          ) : (
                            <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                              <div className='flex animate-pulse flex-col h-full '>
                                <div className='w-6/12 bg-yellow-50 h-6 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-20 rounded-md '></div>
                                <div className='mt-3 w-32 bg-yellow-2 h-12 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>

                        <div className='mt-1 ml-9'>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            serviceCommentsData?.length > 0 ? (
                              serviceCommentsData.map((item) => (
                                <div className='flex-col' key={item._id}>
                                  <div className='mt-2 p-2 pt-1 pb-0 flex justify-start'>
                                    <div className='flex-row overflow-x-auto pl-2 pr-5 rounded-md py-2 bg-gray-300 peer'>
                                      <div className='flex'>
                                        <img
                                          src={
                                            item?.createdBy?.avatar
                                              ? item?.createdBy?.avatar
                                              : "/assets/images/user.png"
                                          }
                                          alt='User'
                                          referrerPolicy='no-referrer'
                                          className='h-6 w-6 rounded-full '
                                        />
                                        <div className='ml-1 mt-0.5 text-sm font-semibold'>
                                          {item.createdBy.firstname} &bull;{" "}
                                          {format(
                                            new Date(item.createdAt),
                                            "MMM dd yyyy, hh:mm a",
                                          )}
                                        </div>
                                      </div>
                                      <div className='text-xs font-semibold mt-0.5 pt-1 pb-0.25 text-blue-800 '>
                                        <p className='text-shadow'>
                                          {item.tags && item.tags !== ""
                                            ? renderTags(item.tags)
                                            : item.commentType !==
                                              "user-comment"
                                            ? renderTags(item.commentType)
                                            : ""}
                                        </p>
                                      </div>
                                      <div
                                        className='text-xs mt-0.5'
                                        dangerouslySetInnerHTML={{
                                          __html: item.description,
                                        }}></div>
                                    </div>
                                    {state.user._id === item.createdBy._id &&
                                      item.commentType === "user-comment" &&
                                      moment(item?.createdAt).diff(
                                        Date.now(),
                                        "minutes",
                                      ) > -10 && (
                                        <div className='peer-hover:opacity-100 opacity-0 hover:opacity-100'>
                                          <div
                                            className='mt-0 ml-1 p-1 rounded bg-yellow-dark cursor-pointer'
                                            onClick={(e) => {
                                              e.preventDefault();
                                              removeActivity(item._id);
                                            }}>
                                            <img
                                              className={`h-4 w-4`}
                                              src='/assets/icons/trash-filled.png'
                                              alt='Delete'
                                              title='Delete Activity'
                                            />
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  <div className='flex w-full overflow-x-auto'>
                                    {item.attachments?.length > 0 &&
                                    typeof item.attachments !== "string" ? (
                                      item?.attachments?.map((item) => (
                                        <div
                                          key={item.blobName}
                                          className={`mt-1 ml-1.5 text-xs px-1.5 pt-0.5 pb-1 rounded-md z-0  `}>
                                          <div
                                            className={`font-semibold bg-yellow-50  text-yellow-dark p-2 rounded-sm ${
                                              item.blobName ===
                                              downloadBlobFileName
                                                ? "animate-pulse cursor-wait"
                                                : "cursor-pointer"
                                            }`}
                                            onClick={(e) => {
                                              downloadAttachment(
                                                item.blobContainer,
                                                item.blobName,
                                                item.originalname,
                                                item.mimetype,
                                              );
                                            }}>
                                            {item.originalname}
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className='w-full grid justify-items-center font-semibold mt-4 text-sm'>
                                No Activity yet
                              </div>
                            )
                          ) : (
                            <span className='mt-4 block w-full py-0 pl-5 sm:text-sm'>
                              <div className='flex animate-pulse flex-col h-full '>
                                <div className='w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <h2 className='text-base font-semibold leading-3 text-gray-dark mt-8'>
                          Enquiry Activity
                        </h2>
                        <div className='mt-1 ml-9'>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            enquiryCommentsData?.length > 0 ? (
                              enquiryCommentsData.map((item) => (
                                <div className='flex-col' key={item._id}>
                                  <div className='mt-2 p-2 pt-1 pb-0 flex justify-start'>
                                    <div className='flex-row overflow-x-auto pl-2 pr-5 rounded-md py-2 bg-gray-300 peer'>
                                      <div className='flex'>
                                        <img
                                          src={
                                            item?.createdBy?.avatar
                                              ? item?.createdBy?.avatar
                                              : "/assets/images/user.png"
                                          }
                                          alt='User'
                                          referrerPolicy='no-referrer'
                                          className='h-6 w-6 rounded-full '
                                        />
                                        <div className='ml-1 mt-0.5 text-sm font-semibold'>
                                          {item.createdBy.firstname} &bull;{" "}
                                          {format(
                                            new Date(item.createdAt),
                                            "MMM dd yyyy, hh:mm a",
                                          )}
                                        </div>
                                      </div>
                                      <div className='text-xs font-semibold mt-0.5 pt-1 pb-0.25 text-blue-800 '>
                                        <p className='text-shadow'>
                                          {item.tags && item.tags !== ""
                                            ? renderTags(item.tags)
                                            : item.commentType !==
                                              "user-comment"
                                            ? renderTags(item.commentType)
                                            : ""}
                                        </p>
                                      </div>
                                      <div
                                        className='text-xs mt-0.5'
                                        dangerouslySetInnerHTML={{
                                          __html: item.description,
                                        }}></div>
                                    </div>
                                    {state.user._id === item.createdBy._id &&
                                      item.commentType === "user-comment" &&
                                      moment(item?.createdAt).diff(
                                        Date.now(),
                                        "minutes",
                                      ) > -10 && (
                                        <div className='peer-hover:opacity-100 opacity-0 hover:opacity-100'>
                                          <div
                                            className='mt-0 ml-1 p-1 rounded bg-yellow-dark cursor-pointer'
                                            onClick={(e) => {
                                              e.preventDefault();
                                              removeActivity(item._id);
                                            }}>
                                            <img
                                              className={`h-4 w-4`}
                                              src='/assets/icons/trash-filled.png'
                                              alt='Delete'
                                              title='Delete Activity'
                                            />
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  <div className='flex w-full overflow-x-auto'>
                                    {item.attachments?.length > 0 &&
                                    typeof item.attachments !== "string" ? (
                                      item?.attachments?.map((item) => (
                                        <div
                                          key={item.blobName}
                                          className={`mt-1 ml-1.5 text-xs px-1.5 pt-0.5 pb-1 rounded-md z-0  `}>
                                          <div
                                            className={`font-semibold bg-yellow-50  text-yellow-dark p-2 rounded-sm ${
                                              item.blobName ===
                                              downloadBlobFileName
                                                ? "animate-pulse cursor-wait"
                                                : "cursor-pointer"
                                            }`}
                                            onClick={(e) => {
                                              downloadAttachment(
                                                item.blobContainer,
                                                item.blobName,
                                                item.originalname,
                                                item.mimetype,
                                              );
                                            }}>
                                            {item.originalname}
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className='w-full grid justify-items-start font-semibold mt-4 text-sm'>
                                No Activity{" "}
                              </div>
                            )
                          ) : (
                            <span className='mt-4 block w-full py-0 pl-5 sm:text-sm'>
                              <div className='flex animate-pulse flex-col h-full '>
                                <div className='w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className='col-span-4 flex-col'>
                        <div className='mt-0 sm:mt-4 grid grid-cols-12 gap-4 bg-yellow-50 rounded p-4'>
                          <div className='col-span-6'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Assignee
                            </label>
                            {/* {serviceTicketDataFromServer.assignee?._id ? (
                              <div className='bg-yellow-50 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center gap-2 hover:bg-yellow-2 duration-300'>
                                <img
                                  src={
                                    serviceTicketDataFromServer.assignee?.avatar
                                      ? serviceTicketDataFromServer.assignee
                                          ?.avatar
                                      : "/assets/images/user.png"
                                  }
                                  alt='avatar'
                                  referrerPolicy='no-referrer'
                                  className='mt-0.5 h-4 w-4 rounded-full ring-1 ring-yellow-2'
                                />
                                <span className='font-semibold text-sm text-yellow-dark'>
                                  {serviceTicketDataFromServer.assignee
                                    ?.fullname
                                    ? serviceTicketDataFromServer.assignee
                                        .fullname
                                    : serviceTicketDataFromServer.assignee
                                        .firstname}
                                </span>
                              </div>
                            ) : (
                              <div className='bg-gray-200 py-1.5 px-2 rounded-sm flex flex-nowrap justify-center gap-2'>
                                <img
                                  src={"/assets/images/user.png"}
                                  alt='avatar'
                                  referrerPolicy='no-referrer'
                                  className='mt-0.5 h-4 w-4 rounded-full ring-1 ring-yellow-2'
                                />
                                <span className='font-semibold text-sm text-gray-100'>
                                  UnAssigned
                                </span>
                              </div>
                            )} */}
                            <Assignee
                              serviceTicketItem={serviceTicketDataFromServer}
                              editAssigneeId={editAssigneeId}
                              setEditAssigneeId={setEditAssigneeId}
                              userState={state.user}
                            />
                          </div>
                          <div className='col-span-12'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Lead By
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm font-semibold'>
                                {serviceTicketDataFromServer?.enquiryId
                                  ? serviceTicketDataFromServer?.enquiryId
                                      ?.createdBy?.fullname
                                    ? serviceTicketDataFromServer?.enquiryId
                                        ?.createdBy?.fullname
                                    : serviceTicketDataFromServer?.enquiryId
                                        ?.createdBy?.firstname
                                  : serviceTicketDataFromServer?.createdBy
                                      ?.fullname
                                  ? serviceTicketDataFromServer?.createdBy
                                      ?.fullname
                                  : serviceTicketDataFromServer?.createdBy
                                      ?.firstname}
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          <div className='col-span-12'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Service Type
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                {
                                  serviceTicketDataFromServer?.serviceTypeId
                                    ?.name
                                }{" "}
                                >{" "}
                                {
                                  serviceTicketDataFromServer?.subServiceTypeId
                                    ?.name
                                }
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          <div className='col-span-12'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Property Type
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                {
                                  serviceTicketDataFromServer?.propertyOptionId
                                    ?.name
                                }{" "}
                                >{" "}
                                {
                                  serviceTicketDataFromServer
                                    ?.subPropertyOptionId?.name
                                }
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          <div className='col-span-12'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Enquiry Date
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                {serviceTicketDataFromServer?.enquiryId
                                  ? serviceTicketDataFromServer.enquiryId?.leadEnteredDate
                                      ?.toString()
                                      .slice(0, 10)
                                  : "N/A"}
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          {serviceTicketDataFromServer?.enquiryId && (
                            <div className='col-span-12'>
                              <label
                                htmlFor='prefix'
                                className='block text-xs font-medium text-gray-700'>
                                Enquiry Channel
                              </label>
                              {serviceTicketDataFromServer?.serviceTicketID ? (
                                <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                  {serviceTicketDataFromServer?.enquiryId &&
                                    serviceTicketDataFromServer.enquiryId
                                      ?.channel}
                                  {serviceTicketDataFromServer.enquiryId
                                    ?.channel !== undefined &&
                                  serviceTicketDataFromServer.enquiryId?.channel.toLowerCase() ===
                                    "reference"
                                    ? " - " +
                                      serviceTicketDataFromServer.enquiryId
                                        ?.referenceName
                                    : serviceTicketDataFromServer.enquiryId
                                        ?.channel !== undefined &&
                                      serviceTicketDataFromServer.enquiryId?.channel.toLowerCase() ===
                                        "websitelink"
                                    ? " - " +
                                      serviceTicketDataFromServer.enquiryId
                                        ?.websiteLink
                                    : "--"}
                                </span>
                              ) : (
                                <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                  <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                    <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                  </div>
                                </span>
                              )}
                            </div>
                          )}
                          <div className='col-span-12'>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Land Extent
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                {serviceTicketDataFromServer?.enquiryId
                                  ?.landExtent
                                  ? serviceTicketDataFromServer?.enquiryId
                                      ?.landExtent
                                  : ""}
                                &nbsp;
                                {serviceTicketDataFromServer?.enquiryId?.units
                                  ? serviceTicketDataFromServer?.enquiryId
                                      ?.units
                                  : " "}
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          {serviceTicketDataFromServer?.enquiryId?.leadType?.toLowerCase() ===
                            "corporate" && (
                            <div className='col-span-12'>
                              <label
                                htmlFor='prefix'
                                className='block text-xs font-medium text-gray-700'>
                                Corporate Information
                              </label>
                              {serviceTicketDataFromServer?.serviceTicketID ? (
                                <div className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                  <p>
                                    {serviceTicketDataFromServer?.enquiryId
                                      ?.corporateLeadCompanyName +
                                      " | " +
                                      serviceTicketDataFromServer?.enquiryId
                                        ?.corporateLeadCompanyAddress +
                                      " | " +
                                      serviceTicketDataFromServer?.enquiryId
                                        ?.corporateLeadPhone}
                                  </p>
                                </div>
                              ) : (
                                <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                  <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                    <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                  </div>
                                </span>
                              )}
                            </div>
                          )}
                          <div className='col-span-12 text-justify '>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              Background Information
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-1 block w-full py-0 pl-5 pr-2 text-sm leading-5'>
                                {serviceTicketDataFromServer?.enquiryId
                                  ?.backgroundInformation
                                  ? serviceTicketDataFromServer?.enquiryId
                                      ?.backgroundInformation
                                  : "--"}
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                          <div className='col-span-12 text-justify '>
                            <label
                              htmlFor='prefix'
                              className='block text-xs font-medium text-gray-700'>
                              CRM
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <span className='mt-1 block w-full py-0 pl-5 pr-2 text-sm leading-5'>
                                {serviceAddressBook?.crm
                                  ? serviceAddressBook?.crm.fullname
                                  : "--"}
                              </span>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                        </div>
                        <div className='mt-0 sm:mt-4 bg-gray-100 rounded p-4 pt-3'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-semibold text-gray-dark'>
                            Ticket Status
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <div className='flex px-5 space-x-2'>
                              <div className='mt-0'>
                                {!editStatus ? (
                                  <div className='flex space-x-2'>
                                    <div className='pl-1 mt-1 peer'>
                                      {renderStatus(
                                        serviceTicketDataFromServer?.status,
                                      )}
                                    </div>
                                    {(state?.user?.department?.name === "CRM" ||
                                      ["admin", "super-admin"].includes(
                                        state.user.aclGroup.toLowerCase(),
                                      )) &&
                                      !["DROPPED", "COMPLETED"].includes(
                                        serviceTicketDataFromServer?.status,
                                      ) && (
                                        <div
                                          className='ml-0 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                          onClick={(e) => {
                                            setEditStatus(true);
                                          }}>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-5 w-5'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        </div>
                                      )}
                                  </div>
                                ) : (
                                  <div className='mt-1'>
                                    <select
                                      className={`block w-28 py-2 px-3 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                      onBlur={() => {
                                        setEditStatus(false);
                                      }}
                                      onChange={(e) => {
                                        e.preventDefault();
                                        changeStatus(
                                          e.target.value,
                                          e.target.selectedOptions[0].text,
                                        );
                                      }}
                                      value={
                                        serviceTicketDataFromServer?.status
                                      }>
                                      <option value='DROPPED'>DROP</option>
                                      <option>ON-HOLD</option>
                                      <option>IN-PROCESS</option>
                                      <option>DATABASE</option>
                                      <option>FOLLOW-UP</option>
                                    </select>
                                  </div>
                                )}
                              </div>

                              <div className='mt-0.5 pt-0.5 font-semibold text-base'>
                                &gt;
                              </div>
                              <div className='mt-0'>
                                {!editSubStatus ? (
                                  <div className='flex flex-row'>
                                    <div className='pl-1 peer font-semibold mt-1'>
                                      {serviceTicketDataFromServer?.subStatusId ? (
                                        <span className='bg-yellow-50 text-yellow-dark text-sm font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-50 dark:text-yellow-dark'>
                                          {
                                            serviceTicketDataFromServer
                                              ?.subStatusId?.name
                                          }
                                        </span>
                                      ) : (
                                        "Unassigned"
                                      )}
                                    </div>
                                    {serviceTicketDataFromServer?.status ===
                                      "IN-PROCESS" && (
                                      <>
                                        <div
                                          className='ml-2 mt-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                          onClick={(e) => {
                                            setEditSubStatus(true);
                                          }}>
                                          <svg
                                            xmlns='http://www.w3.org/2000/svg'
                                            className='h-6 w-6'
                                            viewBox='0 0 20 20'
                                            fill='currentColor'>
                                            <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                          </svg>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                ) : (
                                  <div className='pl-2 peer font-semibold'>
                                    <select
                                      onChange={(e) => {
                                        e.preventDefault();
                                        changeSubStatus(
                                          e.target.value,
                                          e.target.selectedOptions[0].text,
                                        );
                                      }}
                                      defaultValue={
                                        serviceTicketDataFromServer?.subStatusId
                                          ?._id
                                      }
                                      className=' block py-1 px-3 border w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                      <option key='0' value=''>
                                        Select
                                      </option>
                                      {serviceSubStatusData.length > 0 ? (
                                        serviceSubStatusData.map((item) => (
                                          <option
                                            key={item?._id}
                                            value={item?._id}>
                                            {item?.name}
                                          </option>
                                        ))
                                      ) : (
                                        <option>
                                          No SubStatus for this Service /
                                          Sub-Service
                                        </option>
                                      )}
                                    </select>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                              <div className='flex animate-pulse flex-col h-full '>
                                <div className='w-6/12 bg-gray-50 h-6 rounded-md '></div>
                                <div className='mt-3 ml-5 w-6/12 bg-gray-700 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-0 sm:mt-4 bg-yellow-50 rounded p-4 pt-3'>
                          <div className='flex justify-between'>
                            <span className='block text-sm font-semibold text-gray-dark mt-1 ml-0.5'>
                              Tasks ({serviceTasksData.length})
                            </span>
                            <Link
                              to={
                                "/servicetask/create/" +
                                serviceTicketDataFromServer?._id
                              }>
                              <button
                                type='button'
                                className='inline-flex items-center px-3 py-1.5 rounded-sm text-xs font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none duration-300'>
                                Add Task
                              </button>
                            </Link>
                          </div>

                          {serviceTicketDataFromServer._id ? (
                            <div className='flex-col'>
                              <div className='mt-1'>
                                {serviceTasksData.length > 0 ? (
                                  serviceTasksData.map((item) => (
                                    <div
                                      key={item._id}
                                      className='w-full flex space-x-2 justify-between my-1 px-2 py-1.5 mt-2 rounded bg-yellow-3 hover:bg-gray-700 hover:text-white duration-300 cursor-pointer'
                                      onClick={(e) => {
                                        navigate("/servicetask/" + item._id);
                                      }}>
                                      <div className='flex'>
                                        <div className='flex justify-center font-semibold text-xs pt-1.5  '>
                                          <span>#{item.serviceTaskID}</span>
                                        </div>
                                        <div className='col-span-8 font-normal text-xs pt-1.5 pl-1.5'>
                                          {item.name.length <= 30
                                            ? item.name
                                            : item.name.slice(0, 28) + "..."}
                                        </div>
                                      </div>
                                      <div className='col-span-3 flex justify-end'>
                                        <img
                                          src={
                                            item?.assignee?.avatar &&
                                            item?.assignee?.avatar?.trim() !==
                                              ""
                                              ? item?.assignee?.avatar
                                              : "/assets/images/user.png"
                                          }
                                          alt='User'
                                          referrerPolicy='no-referrer'
                                          className='h-7 w-7 rounded-full '
                                          title={item?.assignee?.fullname}
                                        />

                                        <div className='pl-1.5 pt-0'>
                                          {renderServiceTaskStatus(
                                            item?.status,
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <div className='font-semibold ml-7 mt-1'>
                                    <span className=''>
                                      No active tasks for this service
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                              <div className='flex animate-pulse flex-col h-full '>
                                <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className='mt-5 flex-col block sm:hidden'>
                      <div className=''>
                        <label
                          htmlFor='prefix'
                          className='block text-sm font-semibold text-gray-dark'>
                          Service Information
                        </label>
                        {serviceTicketDataFromServer?.serviceTicketID ? (
                          <span className='mt-0 block w-full py-0 pl-0 text-xs font-normal text-justify leading-4 '>
                            {serviceTicketDataFromServer?.enquiryId
                              ? serviceTicketDataFromServer.enquiryId
                                  .serviceInformation
                              : serviceTicketDataFromServer?.serviceInformation}
                          </span>
                        ) : (
                          <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                              <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='mt-3 bg-yellow-50 rounded p-2'>
                        <div className=''>
                          <label
                            htmlFor='prefix'
                            className='block text-xs font-medium text-gray-700'>
                            Lead By
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-5 text-xs font-semibold'>
                              {serviceTicketDataFromServer?.enquiryId
                                ? serviceTicketDataFromServer?.enquiryId
                                    ?.createdBy?.fullname
                                  ? serviceTicketDataFromServer?.enquiryId
                                      ?.createdBy?.fullname
                                  : serviceTicketDataFromServer?.enquiryId
                                      ?.createdBy?.firstname
                                : serviceTicketDataFromServer?.createdBy
                                    ?.fullname
                                ? serviceTicketDataFromServer?.createdBy
                                    ?.fullname
                                : serviceTicketDataFromServer?.createdBy
                                    ?.firstname}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-5 sm:text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700'>
                            Service Type
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-3 text-xs'>
                              {serviceTicketDataFromServer?.serviceTypeId?.name}{" "}
                              >{" "}
                              {
                                serviceTicketDataFromServer?.subServiceTypeId
                                  ?.name
                              }
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            Property Type
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-3 text-xs'>
                              {
                                serviceTicketDataFromServer?.propertyOptionId
                                  ?.name
                              }{" "}
                              >{" "}
                              {
                                serviceTicketDataFromServer?.subPropertyOptionId
                                  ?.name
                              }
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            Enquiry Date
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-3 text-xs'>
                              {serviceTicketDataFromServer?.enquiryId
                                ? serviceTicketDataFromServer.enquiryId?.leadEnteredDate
                                    ?.toString()
                                    .slice(0, 10)
                                : "N/A"}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            Enquiry Channel
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-3 text-xs'>
                              {serviceTicketDataFromServer?.enquiryId &&
                                serviceTicketDataFromServer.enquiryId?.channel}
                              {serviceTicketDataFromServer.enquiryId
                                ?.channel !== undefined &&
                              serviceTicketDataFromServer.enquiryId?.channel.toLowerCase() ===
                                "reference"
                                ? " - " + serviceTicketDataFromServer.enquiryId
                                : serviceTicketDataFromServer.enquiryId
                                    ?.channel !== undefined &&
                                  serviceTicketDataFromServer.enquiryId?.channel.toLowerCase() ===
                                    "websitelink"
                                ? " - " +
                                  serviceTicketDataFromServer.enquiryId
                                    ?.websiteLink
                                : "--"}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>

                        <div className='mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            Land Extent
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pl-3 text-xs'>
                              {serviceTicketDataFromServer?.enquiryId
                                ?.landExtent
                                ? serviceTicketDataFromServer?.enquiryId
                                    ?.landExtent
                                : ""}
                              &nbsp;
                              {serviceTicketDataFromServer?.enquiryId?.units
                                ? serviceTicketDataFromServer?.enquiryId?.units
                                : " "}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        {serviceTicketDataFromServer?.enquiryId?.leadType?.toLowerCase() ===
                          "corporate" && (
                          <div className='mt-4'>
                            <label
                              htmlFor='prefix'
                              className='block text-sm font-medium text-gray-700 mt-1'>
                              Corporate Information
                            </label>
                            {serviceTicketDataFromServer?.serviceTicketID ? (
                              <div className='mt-0 block w-full py-0 pl-3 text-xs'>
                                <p>
                                  {serviceTicketDataFromServer?.enquiryId
                                    ?.corporateLeadCompanyName +
                                    " | " +
                                    serviceTicketDataFromServer?.enquiryId
                                      ?.corporateLeadCompanyAddress +
                                    " | " +
                                    serviceTicketDataFromServer?.enquiryId
                                      ?.corporateLeadPhone}
                                </p>
                              </div>
                            ) : (
                              <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                                <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                  <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                        )}
                        <div className='text-justify mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            Background Information
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pb-1 pl-1 pr-2 text-xs leading-4'>
                              {serviceTicketDataFromServer?.enquiryId
                                ?.backgroundInformation
                                ? serviceTicketDataFromServer?.enquiryId
                                    ?.backgroundInformation
                                : "--"}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='text-justify mt-4'>
                          <label
                            htmlFor='prefix'
                            className='block text-sm font-medium text-gray-700 mt-1'>
                            CRM
                          </label>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <span className='mt-0 block w-full py-0 pb-1 pl-1 pr-2 text-xs leading-4'>
                              {serviceAddressBook?.crm
                                ? serviceAddressBook?.crm.fullname
                                : "--"}
                            </span>
                          ) : (
                            <span className='mt-0 block w-full py-0 pl-3 text-sm'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-center'>
                                <div className='w-full bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className='mt-3 bg-gray-100 rounded p-2'>
                        <label
                          htmlFor='prefix'
                          className='block text-sm font-semibold text-gray-dark'>
                          Ticket Status
                        </label>
                        {serviceTicketDataFromServer?.serviceTicketID ? (
                          <div className='flex ml-5 space-x-2'>
                            <div className='mt-0'>
                              {!editStatus ? (
                                <div className='pl-1 mt-1 flex'>
                                  <div className='peer'>
                                    {renderStatus(
                                      serviceTicketDataFromServer?.status,
                                    )}
                                  </div>
                                  {(state?.user?.department?.name === "CRM" ||
                                    ["admin", "super-admin"].includes(
                                      state.user.aclGroup.toLowerCase(),
                                    )) &&
                                    !["DROPPED", "COMPLETED"].includes(
                                      serviceTicketDataFromServer?.status,
                                    ) && (
                                      <div
                                        className='ml-0 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                        onClick={(e) => {
                                          if (
                                            state?.user?.department?.name ===
                                              "CRM" ||
                                            ["admin", "super-admin"].includes(
                                              state.user.aclGroup.toLowerCase(),
                                            )
                                          )
                                            setEditStatus(true);
                                        }}>
                                        {state?.user?.department?.name ===
                                          "CRM" ||
                                          (["admin", "super-admin"].includes(
                                            state.user.aclGroup.toLowerCase(),
                                          ) && (
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              className='h-4 w-4'
                                              viewBox='0 0 20 20'
                                              fill='currentColor'>
                                              <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                            </svg>
                                          ))}
                                      </div>
                                    )}
                                </div>
                              ) : (
                                <div className='mt-1'>
                                  <select
                                    className={`block w-28 py-1 px-2 border bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 text-xs`}
                                    onBlur={() => {
                                      setEditStatus(false);
                                    }}
                                    onChange={(e) => {
                                      e.preventDefault();
                                      if (
                                        state?.user?.department?.name ===
                                          "CRM" ||
                                        ["admin", "super-admin"].includes(
                                          state.user.aclGroup.toLowerCase(),
                                        )
                                      )
                                        changeStatus(
                                          e.target.value,
                                          e.target.selectedOptions[0].text,
                                        );
                                    }}
                                    value={serviceTicketDataFromServer?.status}>
                                    <option value='DROPPED'>DROP</option>
                                    <option>ON-HOLD</option>
                                    <option>IN-PROCESS</option>
                                    <option>DATABASE</option>
                                    <option>FOLLOW-UP</option>
                                  </select>
                                </div>
                              )}
                            </div>

                            <div className='mt-0.5 pt-0.5 font-semibold text-base'>
                              &gt;
                            </div>
                            <div className='mt-0'>
                              {!editSubStatus ? (
                                <div className='flex flex-row'>
                                  <div className='pl-1 peer font-semibold mt-1'>
                                    {serviceTicketDataFromServer?.subStatusId ? (
                                      <span className='bg-yellow-50 text-yellow-dark text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-yellow-50 dark:text-yellow-dark'>
                                        {
                                          serviceTicketDataFromServer
                                            ?.subStatusId?.name
                                        }
                                      </span>
                                    ) : (
                                      "Unassigned"
                                    )}
                                  </div>
                                  {serviceTicketDataFromServer?.status ===
                                    "IN-PROCESS" && (
                                    <>
                                      <div
                                        className='ml-2 mt-2 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                        onClick={(e) => {
                                          if (
                                            state?.user?.department?.name ===
                                              "CRM" ||
                                            ["admin", "super-admin"].includes(
                                              state.user.aclGroup.toLowerCase(),
                                            )
                                          )
                                            setEditSubStatus(true);
                                        }}>
                                        {state?.user?.department?.name ===
                                          "CRM" ||
                                          (["admin", "super-admin"].includes(
                                            state.user.aclGroup.toLowerCase(),
                                          ) && (
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              className='h-4 w-4'
                                              viewBox='0 0 20 20'
                                              fill='currentColor'>
                                              <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                            </svg>
                                          ))}
                                      </div>
                                    </>
                                  )}
                                </div>
                              ) : (
                                <div className='pl-2 peer font-semibold'>
                                  <select
                                    onChange={(e) => {
                                      e.preventDefault();
                                      if (
                                        state?.user?.department?.name ===
                                          "CRM" ||
                                        ["admin", "super-admin"].includes(
                                          state.user.aclGroup.toLowerCase(),
                                        )
                                      )
                                        changeSubStatus(
                                          e.target.value,
                                          e.target.selectedOptions[0].text,
                                        );
                                    }}
                                    onBlur={() => {
                                      setEditSubStatus(false);
                                    }}
                                    defaultValue={
                                      serviceTicketDataFromServer?.subStatusId
                                        ?._id
                                    }
                                    className=' block py-1 px-3 border w-full bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-xs'>
                                    <option key='0' value=''>
                                      Select
                                    </option>
                                    {serviceSubStatusData.length > 0 ? (
                                      serviceSubStatusData.map((item) => (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item?.name}
                                        </option>
                                      ))
                                    ) : (
                                      <option>
                                        No SubStatus for this Service /
                                        Sub-Service
                                      </option>
                                    )}
                                  </select>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                            <div className='flex animate-pulse flex-col h-full '>
                              <div className='w-6/12 bg-gray-50 h-6 rounded-md '></div>
                              <div className='mt-3 ml-5 w-6/12 bg-gray-700 h-6 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <div className='mt-3 bg-yellow-50 rounded p-2'>
                        <div className='flex justify-between'>
                          <span className='block text-sm font-semibold text-gray-dark mt-1 ml-0.5'>
                            Tasks ({serviceTasksData.length})
                          </span>
                          <Link
                            to={
                              "/servicetask/create/" +
                              serviceTicketDataFromServer?._id
                            }>
                            <button
                              type='button'
                              className='inline-flex items-center px-3 py-1.5 rounded-sm text-xs font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none duration-300'>
                              Add Task
                            </button>
                          </Link>
                        </div>

                        {serviceTicketDataFromServer._id ? (
                          <div className='flex '>
                            <div className='mt-1'>
                              {serviceTasksData.length > 0 ? (
                                serviceTasksData.map((item) => (
                                  <div
                                    key={item._id}
                                    className='grid grid-cols-12 gap-2 my-1 px-4 py-1.5 mt-2 rounded bg-yellow-3 hover:bg-gray-700 hover:text-white duration-300 cursor-pointer'
                                    onClick={(e) => {
                                      navigate("/servicetask/" + item._id);
                                    }}>
                                    <div className='flex justify-center font-normal text-xs pt-1.5  '>
                                      <span>#{item.serviceTaskID}</span>
                                    </div>
                                    <div className='col-span-8 font-normal text-xs pt-1.5 pl-1.5'>
                                      {item.name.length <= 30
                                        ? item.name
                                        : item.name.slice(0, 28) + "..."}
                                    </div>
                                    <div className='col-span-3 flex justify-center'>
                                      <img
                                        src={
                                          item?.assignee?.avatar &&
                                          item?.assignee?.avatar?.trim() !== ""
                                            ? item?.assignee?.avatar
                                            : "/assets/images/user.png"
                                        }
                                        alt='User'
                                        referrerPolicy='no-referrer'
                                        className='h-7 w-7 rounded-full '
                                        title={item?.assignee?.fullname}
                                      />

                                      <div className='pl-1.5 pt-0'>
                                        {renderServiceTaskStatus(item?.status)}
                                      </div>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className='font-semibold ml-7 mt-0'>
                                  <span className='text-sm'>
                                    No active tasks for this service
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                            <div className='flex animate-pulse flex-col h-full '>
                              <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                              <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                              <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                              <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                              <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                      <h2 className='text-base font-semibold leading-3 text-gray-dark mt-8'>
                        Activity
                      </h2>
                      <div className='my-2 p-0 pt-1 pb-0 flex'>
                        <div className='p-1'>
                          {serviceTicketDataFromServer?.serviceTicketID ? (
                            <img
                              src={
                                state?.user?.avatar
                                  ? state?.user?.avatar
                                  : "/assets/images/user.png"
                              }
                              alt='User'
                              referrerPolicy='no-referrer'
                              className='h-7 w-7 rounded-full '
                            />
                          ) : (
                            <div className='animate-pulse w-8 bg-gray-300 h-8 rounded-full'></div>
                          )}
                        </div>
                        {serviceTicketDataFromServer?.serviceTicketID ? (
                          <div className='flex-row overflow-x-auto px-3 rounded-lg py-3 bg-gray-100 w-full'>
                            <form
                              action='#'
                              method='POST'
                              id='serviceCommentForm1'
                              noValidate
                              onSubmit={(event) => {
                                event.preventDefault();
                                postComment(event);
                              }}>
                              <div className='text-xs font-semibold py-0.25 text-blue-800 '>
                                <input
                                  type='text'
                                  name='commentTags'
                                  id='commentTags'
                                  maxLength='50'
                                  placeholder='Tags can be split using spacebar'
                                  className={`mt-0 focus:ring-yellow-2 focus:border-yellow-2 block sm:w-6/12 w-full shadow-sm text-xs border-0 bg-yellow-50 py-1 px-2 rounded-sm`}
                                />
                              </div>
                              <textarea
                                name='commentDescription'
                                id='commentDescription'
                                rows={4}
                                placeholder='Write Comments here..'
                                className={`mt-1 w-full border-0 bg-gray-50 ${
                                  !validCommentDescription
                                    ? "border ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2"
                                }  block shadow-sm sm:text-xs  rounded-md`}
                              />
                              {!validCommentDescription && (
                                <p className='text-red-600 text-xs font-semibold'>
                                  Comment invalid
                                </p>
                              )}
                              <div className='flex'>
                                {commentAttachments.length > 0 ? (
                                  commentAttachments.map((item) => (
                                    <div
                                      key={item.blobName}
                                      className='my-2 mr-1 px-1.5 py-1 bg-white rounded z-0'>
                                      <div className='flex'>
                                        <div className='font-semibold text-yellow-dark mt-1 text-xs'>
                                          {item.originalname?.length > 15
                                            ? item.originalname?.slice(0, 15) +
                                              "..."
                                            : item.originalname}
                                        </div>
                                        <div
                                          className='ml-2 pt-1 cursor-pointer'
                                          onClick={(e) => {
                                            e.preventDefault();
                                            removeCommentAttachment(
                                              item.blobName,
                                            );
                                          }}>
                                          <img
                                            className={`h-5 w-5`}
                                            src='/assets/icons/trash-filled.png'
                                            alt='X'
                                            title='Remove attachment'
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className=''>
                                {isFileUploading ? (
                                  <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer animate-bounce opacity-60'>
                                    <p className='p-3'>
                                      File Uploading to Server...
                                    </p>
                                  </div>
                                ) : (
                                  <FileUploader
                                    handleChange={uploadCommentAttachments}
                                    name='attachments'
                                    multiple={true}
                                    label='Upload or Drop files to move enquiry to Service ticket'
                                    children={
                                      <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer'>
                                        <p className='p-3'>
                                          Drag &amp; Drop files here
                                        </p>
                                      </div>
                                    }
                                    types={["JPG", "PNG", "PDF"]}
                                  />
                                )}
                              </div>
                              <div className='ml-0 pb-1'>
                                {!requestLoading ? (
                                  <button
                                    id='submitBtn'
                                    type='submit'
                                    className='mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                                    Add Activity
                                  </button>
                                ) : (
                                  <button
                                    className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                                    disabled={true}>
                                    Processing...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        ) : (
                          <span className='mt-1 block w-full py-0 pl-2 sm:text-sm'>
                            <div className='flex animate-pulse flex-col h-full '>
                              <div className='w-6/12 bg-yellow-50 h-6 rounded-md '></div>
                              <div className='mt-3 w-10/12 bg-gray-100 h-20 rounded-md '></div>
                              <div className='mt-3 w-32 bg-yellow-2 h-12 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>

                      <div className='mt-1 ml-5'>
                        {serviceTicketDataFromServer?.serviceTicketID ? (
                          serviceCommentsData?.length > 0 ? (
                            serviceCommentsData.map((item) => (
                              <div className='flex-col'>
                                <div
                                  key={item._id}
                                  className='mt-2 p-2 pt-1 pb-0 flex justify-start'>
                                  <div className='flex-row overflow-x-auto pl-2 pr-5 rounded-lg py-2 bg-gray-300 peer'>
                                    <div className='flex'>
                                      <img
                                        src={
                                          item?.createdBy?.avatar
                                            ? item?.createdBy?.avatar
                                            : "/assets/images/user.png"
                                        }
                                        alt='User'
                                        referrerPolicy='no-referrer'
                                        className='h-6 w-6 rounded-full '
                                      />
                                      <div className='ml-1 mt-0.5 text-sm font-semibold'>
                                        {item.createdBy.firstname} &bull;{" "}
                                        {format(
                                          new Date(item.createdAt),
                                          "MMM dd yyyy, hh:mma",
                                        )}
                                      </div>
                                    </div>
                                    <div className='text-xs font-semibold mt-0.5 pt-1 pb-0.25 text-blue-800 '>
                                      <p className='text-shadow'>
                                        {item.tags && item.tags !== ""
                                          ? renderTags(item.tags)
                                          : item.commentType !== "user-comment"
                                          ? renderTags(item.commentType)
                                          : ""}
                                      </p>
                                    </div>
                                    <div
                                      className='text-xs mt-0.5'
                                      dangerouslySetInnerHTML={{
                                        __html: item.description,
                                      }}></div>
                                  </div>
                                  {state.user._id === item.createdBy._id &&
                                    item.commentType === "user-comment" &&
                                    moment(item?.createdAt).diff(
                                      Date.now(),
                                      "minutes",
                                    ) > -10 && (
                                      <div className='peer-hover:opacity-100 opacity-0 hover:opacity-100'>
                                        <div
                                          className='mt-0 ml-1 p-0.5 rounded bg-yellow-dark cursor-pointer'
                                          onClick={(e) => {
                                            e.preventDefault();
                                            removeActivity(item._id);
                                          }}>
                                          <img
                                            className={`h-5 w-5`}
                                            src='/assets/icons/trash-filled.png'
                                            alt='Delete'
                                            title='Delete Activity'
                                          />
                                        </div>
                                      </div>
                                    )}
                                </div>
                                <div className='flex'>
                                  {item.attachments?.length > 0 &&
                                  typeof item.attachments !== "string" ? (
                                    item.attachments.map((item) => (
                                      <div
                                        key={item.destFilePath}
                                        className='ml-1.5 text-xs px-1.5 pt-0.5 pb-1 bg-yellow-50 rounded-md z-0 cursor-pointer'
                                        onClick={(e) => {
                                          //   item.blobContainer,
                                          //   item.blobName,
                                          //   item.originalname,
                                          //   item.mimetype,
                                          // );
                                          downloadAttachment(
                                            item.bucket,
                                            item.blobName,
                                            item.originalname,
                                            item.contentType,
                                          );
                                        }}>
                                        <div className='flex'>
                                          <div className='font-semibold text-yellow-dark'>
                                            {item.originalname}
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className='w-full grid justify-items-center font-semibold mt-4 text-sm'>
                              No Activity yet
                            </div>
                          )
                        ) : (
                          <span className='mt-4 block w-full py-0 pl-5 sm:text-sm'>
                            <div className='flex animate-pulse flex-col h-full '>
                              <div className='w-10/12 bg-gray-100 h-12 rounded-md '></div>
                              <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                              <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                              <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-xs font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </button>
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ServicesViewSpecific;
